import { BodyText } from "@/components/ui/Text";
import { Clock } from "lucide-react";

export const AsyncChatIndicator = () => {
  return (
    <div className="flex items-center gap-1 text-tertiary">
      <Clock className="w-3 h-3" />
      <BodyText size="xs" textColor="tertiary">
        Async message
      </BodyText>
    </div>
  );
};
